'use strict';

var invoke = require('../utils/invoke');
var type = require('../value/type');

module.exports = function () {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (type(args[0]) === 'object') {
    return Object.assign.apply(Object, [{}].concat(args));
  }
  return invoke('concat').apply(undefined, args);
};


//////////////////
// WEBPACK FOOTER
// ./~/fun-util/lib/iterable/concat.js
// module id = 554
// module chunks = 37